export enum BadgeCssClassStatusEnum {
  info = 'badge-light-info',
  success = 'badge-light-success',
  warning = 'badge-light-warning',
  danger = 'badge-light-danger',
  primary = 'badge-light-primary',
  secondary = 'badge-light-secondary',
}
